var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1091_2448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9971 24C18.5865 24 24 18.5853 24 12C24 5.40909 18.5808 0 11.9914 0C5.41349 0 0 5.40909 0 12C0 18.5853 5.41916 24 11.9971 24ZM11.9914 21.7102C9.56591 21.7102 6.74272 20.6989 5.07833 18.858C6.49277 16.8522 8.9581 15.7443 11.9914 15.7443C15.0021 15.7443 17.4845 16.8296 18.916 18.858C17.2402 20.6989 14.4228 21.7102 11.9914 21.7102ZM11.9914 13.7273C9.70793 13.7159 7.94697 11.7841 7.94697 9.30682C7.93562 6.96023 9.73632 4.96023 11.9914 4.96023C14.258 4.96023 16.0417 6.96023 16.0417 9.30682C16.0417 11.7841 14.2864 13.7386 11.9914 13.7273Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1091_2448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.df5797b34dcc5405dbb40399c3012bd2.svg";
export { ForwardRef as ReactComponent };